import React, { Component } from "react";
import { DateRangePicker } from "@matharumanpreet00/react-daterange-picker";

import "./App.css";
import { DateRange } from "@matharumanpreet00/react-daterange-picker/build/types";

class App extends Component<{}, { open: boolean; dateRange: DateRange }> {
	state = {
		open: true,
		dateRange: {}
	};

	render() {
		return (
			<div className="App">
				<header className="App-header">
					<DateRangePicker
						title="my title"
						open={this.state.open}
						onChange={range => this.setState({ dateRange: range })}
					/>

					<pre style={{ color: "black" }}>
						{JSON.stringify(this.state.dateRange, null, 4)}
					</pre>
				</header>
			</div>
		);
	}
}

export default App;
